import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../elements/Humberg';
import { useDispatch, useSelector } from 'react-redux';
import LoaderBlock from '../loader/LoaderBlock';
import SingleOrder from './SingleOrder';
import DateFilter from '../../elements/DateFilter';

import TopBarValues from './topBarValues';
import Filters from './Filters';
import { allProductTypesAction } from '../../redux/actions/userActions';
import Loader from '../loader/loader';
import { CREATE_ORDER_RESET } from '../../redux/constants/orderConstants';
import { multiMarkAsCommissionedAction } from '../../redux/actions/orderActions';



/*************  ✨ Windsurf Command 🌟  *************/
const PMMpending = () => {



    const dispatch = useDispatch()


    const { loading,
        orders,
        totalPages,
        commissionedCount,
    } = useSelector((state) => state.orders)

    const { user } = useSelector(state => state.verifyEmailStore);
    const { loading: orderLoading,  message } = useSelector(state => state.order)




    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [pmmCommission, setPmmCommission] = useState(0);
    const [portalCommission, setPortalCommission] = useState(0);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [isMulti, setIsMulti] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');


    // Remove one quantity



    useEffect(() => {

        dispatch(allProductTypesAction())
        document.title = "PMM Pending Commission";

    }, [dispatch])






    useEffect(() => {
        if (message) {
            if (isMulti) {
                setSuccessMessage(message)
            }
            setIsMulti(false)
            setShowPopup(false)
            setSelectedOrders([])
            dispatch({ type: CREATE_ORDER_RESET })
        }
    }, [message, dispatch, isMulti])



    useEffect(() => {


        if (orders?.length > 0) {

            let pmmTotal = 0;
            let portalTotal = 0;

            orders.forEach((order) => {

                pmmTotal = pmmTotal + Number(order?.pm_commission_amount) || 0;
                portalTotal = portalTotal + Number(order?.portal_commission_amount) || 0;
            })

            setPmmCommission(pmmTotal);
            setPortalCommission(portalTotal);
        }


    }, [orders])


    const handleDispatch = () => {


        dispatch(multiMarkAsCommissionedAction({ order_ids: selectedOrders }))

        setIsMulti(true)

    }


    return (
        <Fragment>
            {orderLoading && <Loader />}
            <Humberg header="Dashboard" headerLink="/" children={user?.role !== "PMM" ? "PMM Pending Commission" : "Pending Payouts"} />
            <DateFilter
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
            />
            <section className="p-[1.5vmax] mt-[1vmax]" >
                <TopBarValues
                    commissionedCount={commissionedCount}
                    pmmCommission={pmmCommission}
                    portalCommission={portalCommission}
                    totalOrders={orders?.length}

                />
                <Filters page={page} setPage={setPage} dateFrom={dateFrom} dateTo={dateTo} />
                <div className="bg-white flex justify-between items-center  px-[2vmax] pt-[2vmax] pb-[1vmax]">
                    <div className="flex-center">
                        <span className='flex-center' >Select All &nbsp;&nbsp;:&nbsp;&nbsp;</span>
                        <input
                            type="checkbox"
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedOrders(orders.map(r => r.id));
                                } else {
                                    setSelectedOrders([]);
                                }
                            }}
                        />
                    </div>
                    {selectedOrders?.length > 0 && (

                        <button
                            className="bg-[image:var(--gradient-purple)] text-white px-[1vmax] py-[0.5vmax] rounded-lg mb-[1vmax]  text-[1.5vmax] lg:text-[0.9vmax]"
                            onClick={() => setShowPopup(true)}
                        >
                            Mark as Commissioned ({selectedOrders.length})
                        </button>
                    )}
                </div>
                {successMessage &&

                    <div className="w-fit  bg-blue-100 relative z-[1] text-blue-500 flex gap-[1vmax] p-[0.3vmax_1vmax] text-[1vmax] font-bold mx-[2vmax]">
                        <span>{successMessage}</span>
                        <button onClick={() => setSuccessMessage("")} ><i className="fa-xmark fa-solid"></i></button>
                    </div>
                }

                <div className="bg-white p-[2vmax] lg:mt-[-2vmax]  shadow-1 rounded-b-lg overflow-x-auto my-scroll-2 my-scroll-3">

                    <div className="min-w-[1200px] mt-[2vmax] border border-gray-200 rounded-xl shadow-sm bg-white">
                        {/* Header */}
                        <div 
                            className="grid bg-gray-50 py-[1vmax] items-center border-b border-gray-200 rounded-t-xl"
                            style={{ gridTemplateColumns: 'minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 1.2fr) minmax(0, 1.2fr) minmax(0, 2.2fr) minmax(0, 1.8fr) minmax(0, 3fr)' }}
                        >
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                Select
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                Order ID
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                Product ID
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                Seller
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                PM
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                PM Earnings
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                Portal Earnings
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                Refunded At
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                Status
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.2vmax] lg:text-[0.8vmax] font-bold" >
                                Actions
                            </div>
                        </div>

                        {/* Rows */}
                        {loading ?
                            <LoaderBlock />
                            :
                            orders?.length > 0 ?
                                orders.map((order) => (
                                    <SingleOrder key={order.id} order={order} user={user} selectedOrders={selectedOrders} setSelectedOrders={setSelectedOrders} />
                                ))
                                :
                                <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                    No data found
                                </div>
                        }
                    </div>
                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}


            {showPopup &&
                <section className="w-[100%] min-h-[100vh] flex-center fixed top-0 left-0 bg-[#000000b7] z-[99999999999]">
                    <button className="fixed top-[2vmax] right-[2vmax]"
                        onClick={() => setShowPopup(false)}
                    >
                        <i className="fa-solid fa-xmark text-white text-[2vmax]"></i>
                    </button>
                    <div className="bg-white rounded-xl  shadow-1 overflow-hidden w-[35%]">
                        <div className="font-3 font-[700] text-white bg-[image:var(--gradient-2)] py-[0.6vmax] text-center text-[1.5vmax]">
                            Mark as Commissioned
                        </div>
                        <p className='p-[1.5vmax] text-[1.1vmax] font-3  text-slate-700 whitespace-pre-line' >
                            By marking this order as Commissioned, you confirm that the order has been successfully completed and the commission can be processed. Please ensure all necessary steps have been taken and the order is ready for commissioning before proceeding.
                        </p>
                        <div className="flex justify-end gap-[1.5vmax] p-[1.5vmax]">
                            <button className="text-[1.1vmax] font-3 bg-gray-500 text-white 
                                      p-[0.5vmax_1vmax] rounded-lg "
                                onClick={() => {
                                    setShowPopup(false)
                                }}
                            >No</button>


                            <button className="text-[1.1vmax] font-3 bg-[image:var(--gradient-2)] text-white 
                            p-[0.5vmax_1vmax] rounded-lg"
                                onClick={handleDispatch}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </section>
            }
            <br />
            <br />
            <br />
            <br />
        </Fragment>
    )
}

export default PMMpending